import { Link } from "react-router-dom";

const Navigation = () => {
    return (
        <nav className="bg-blue-500 p-4">
            <ul className="flex justify-around">
                <li>
                    <Link to="/" className="px-4 py-2 m-2 transition-colors duration-200 text-white hover:bg-white hover:text-blue-500 font-bold">Home</Link>
                </li>
                <li>
                    <Link to="/about" className="px-4 py-2 m-2 transition-colors duration-200 text-white hover:bg-white hover:text-blue-500 font-bold">About</Link>
                </li>
                <li>
                    <Link to="/contact" className="px-4 py-2 m-2 transition-colors duration-200 text-white hover:bg-white hover:text-blue-500 font-bold">Contact</Link>
                </li>
            </ul>
        </nav>
    );
}

export default Navigation;